export default __webpack_public_path__ + "static/media/icon-hat.1158c930.svg";